import React from 'react';
import { RenderElementProps } from 'slate-react';
import { extractCustomBlockFields } from '../PowerDoc/plugins/CustomFieldsBlock';
import { DashboardPage } from './DashboardPage';

export const DashboardBlock = (props: RenderElementProps) => {
  const fields = extractCustomBlockFields(props.element);

  return fields.dashboard
    ? (
    <DashboardPage
      hideTitle
      isEmbeded
      defaultDashboard={fields.dashboard}
      hideRefresh={!!fields.no_refresh}
      />
    )
    : null;
}
